/**
 * @file Discover Album Folder No Face Recognition Join view.
 */

import React from 'react';
import PropTypes from 'prop-types';

import DiscoverAlbumFolderNoFrJoin from '../../components/discover/DiscoverAlbumFolderNoFrJoin';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string,
    }),
  }),
};

const DiscoverAlbumFolderNoFrJoinView = ({ match }) => (
  <DiscoverAlbumFolderNoFrJoin albumFolderId={match.params.albumFolderId} />
);

DiscoverAlbumFolderNoFrJoinView.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinView;
